// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"156ae860","513":"d699a20c","703":"3da2b171","787":"19a5abe6"}[chunkId] + ".chunk.js";
};